import { BillingCadence } from '@fruitful/types';
import capitalize from 'lodash/capitalize';

const cadenceLabel = (c: BillingCadence): string =>
    capitalize(c.toLowerCase().split('_').join(' '));

/** Cadence options for Money Map bills (matches take-home GroveMoneyMapPickerField pattern). */
export const moneyMapperBillCadencePickerOptions = Object.values(BillingCadence)
    .filter((c) => c !== BillingCadence.YEARLY)
    .map((value) => ({
        value,
        label: cadenceLabel(value),
    }));
